/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

function useAnnouncer(textCount, maxCount) {
  let entityName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'characters';
  const lastTen = maxCount - 10;
  if (textCount >= lastTen) {
    return `${maxCount - textCount} ${entityName} left.`;
  }
}

export { useAnnouncer };
